import { ConfigService } from './../../../services/config.service';
import { NGXLogger } from 'ngx-logger';

import { Component } from '@angular/core';
import { ScrEnvironment } from 'src/environments/environment';
import { ScrAuthenticationService } from 'src/app/services/authentication.service';
import { Router } from '@angular/router';
import { ScrBaseComponent } from '../../base.component';


@Component({
  templateUrl: './forgotusername.component.html',
  styleUrls: ['./forgotusername.component.scss']
})
export class ForgotUserNameComponent extends ScrBaseComponent {

  public emailaddress?: string;
  public submitted = false;
  public pending?: boolean;
  public customerSupportLink?: string;

  constructor(
    public service: ScrAuthenticationService,
    public configService: ConfigService,
    public router: Router,
    private logger: NGXLogger,
    public env: ScrEnvironment) {
      super();

      this.configService.getConfig().subscribe(rsp => {
        this.customerSupportLink = rsp.customerSupportLink;
      });
  }


  public submit(): void {
    if (this.emailaddress) {
      this.clearMessages();
      this.observe(this.service.forgotUsername(this.emailaddress), (rsp) => {
        this.submitted = true;
        this.pending = rsp.pending;
      });
    }
    else {
      this.logger.warn('how did submit get called with missing email');
    }
  }
}
